import Loading from "components/Loading";
import { GetServerSidePropsContext, NextPage } from "next";
import { useRouter } from "next/router";
import { useEffect } from "react";
import getSettings from "utils/getSettings";

const SetCulture: NextPage = ({fromurl}: any) => {
    const router = useRouter();
    
    useEffect(() => {
        if (fromurl && fromurl.includes('floridafinecars.com')) {
            router.push(fromurl);
        }
        else router.push('https://floridafinecars.com');
    }, [router, fromurl]); 

    return <Loading />;
};

export const getServerSideProps = async ({
    query,
    res,
    req,
}: GetServerSidePropsContext) => {
    res.setHeader(
        "Cache-Control",
        `public, s-maxage=${process.env.CACHE_CONTROL_MAX}, stale-while-revalidate=${process.env.CACHE_CONTROL_MAX}`
    );
    const { fromurl } = query as any;
    const { settings } = await getSettings(req);

    return {
        props: {
            fromurl,
            settings,
        },
    };
};

export default SetCulture;